import { render } from "./CardRight.vue?vue&type=template&id=31447b95"
import script from "./CardRight.vue?vue&type=script&lang=js"
export * from "./CardRight.vue?vue&type=script&lang=js"

import "./CardRight.vue?vue&type=style&index=0&id=31447b95&lang=css"

import exportComponent from "C:\\Users\\alla2\\Github\\TPA-Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__